// eslint-disable-next-line import/no-cycle
import View from './view';

export default View;
